import appConfig from 'appConfig';

export const getBannerNotificationFeatureKeyDetails = async (featureFlagName) => {
  const featureKeyData = await fetch(`${appConfig.getLaunchDarklyAPIURL()}${appConfig.projectKey()}/${featureFlagName}`, {
    method: 'GET',
    headers: {
      Authorization: appConfig.getLaunchDarklyAPIKey(),
    },
  }).then((response) => response.json());
  return featureKeyData;
};